import { useAuth } from '@context/AuthContext'

export default function UserCreateButton({ children, className, onClick }) {
  const { isAdmin, isSuperAdmin, canCreateUsers } = useAuth()

  if (!(isAdmin || isSuperAdmin) || !canCreateUsers) return null

  return (
    <button type="button" className={className} onClick={onClick}>
      {children}
    </button>
  )
}
